import { Response } from 'request-dot-js'

export const getNextPageParam = (lastPage: Response<any>, pages: Response<any>[]) => {
  if (lastPage.type === 'exception') return undefined

  const totalPages = Number(lastPage.headers['total-pages'])
  const currentPage = Number(lastPage.headers['current-page'])

  if (!isNaN(totalPages) && !isNaN(currentPage) && totalPages >= 1 && currentPage >= 1) {
    const nextPage = currentPage + 1
    return nextPage <= totalPages ? nextPage : undefined
  }

  const link = lastPage.headers['link']
  if (typeof link === 'string' && /rel="next"/.test(link)) return pages.length + 1

  return undefined
}
